import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import './TIJSidebar.css';


import ZH from '../Pages/ZH';
import ZX1 from '../Pages/ZX1';
import ZX2 from '../Pages/ZX2';
import ZX4 from '../Pages/ZX4';

const TIJLayout = ({ mode }) => {
  // Use URL parameter or default to the provided mode or 'hand-held-printer'
  const { type } = useParams();
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState(type || mode || 'hand-held-printer');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Update URL when activeComponent changes
  useEffect(() => {
    navigate(`/thermal-inkjet-printer/${activeComponent}`);
  }, [activeComponent, navigate]);

  // Handle component switching
  const handleComponentChange = (component) => {
    setActiveComponent(component);
    setIsSidebarOpen(false);
  };

  // Render the active component
  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'hand-held-printer':
        return <ZH/>;
      case 'ZX-Plus-1':
        return <ZX1/>;
      case 'ZX-Plus-2':
        return <ZX2/>;
      case 'ZX-Pro':
        return <ZX4/>;
      default:
        return <ZH/>;
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
      
        {/* Mobile Navigation (Horizontal) */}
        <div className="mobile-nav">
          <button
            className={`nav-link ${activeComponent === 'hand-held-printer' ? 'active' : ''}`}
            onClick={() => handleComponentChange('hand-held-printer')}
          >
            Handheld TIJ
          </button>
          <button
            className={`nav-link ${activeComponent === 'ZX-Plus-1' ? 'active' : ''}`}
            onClick={() => handleComponentChange('ZX-Plus-1')}
          >
            ZX Plus-1
          </button>
          <button
            className={`nav-link ${activeComponent === 'ZX-Plus-2' ? 'active' : ''}`}
            onClick={() => handleComponentChange('ZX-Plus-2')}
          >
            ZX Plus-2
          </button>
          <button
            className={`nav-link ${activeComponent === 'ZX-Pro' ? 'active' : ''}`}
            onClick={() => handleComponentChange('ZX-Pro')}
          >
            ZX Pro Series
          </button>
        </div>

        {/* Hamburger Menu Toggle Button (Visible on Small Screens) */}
        <button
          className="sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="mb-3 ml-4 mt-3" style={{fontSize:"20px", fontWeight:"bold", textDecoration:"underline"}}>Thermal Inkjet Printers</div>
          <nav className="nav flex-column">
            <button
              className={`nav-link ${activeComponent === 'hand-held-printer' ? 'active' : ''}`}
              onClick={() => handleComponentChange('hand-held-printer')}
            >
              Handheld TIJ
            </button>
            <button
              className={`nav-link ${activeComponent === 'ZX-Plus-1' ? 'active' : ''}`}
              onClick={() => handleComponentChange('ZX-Plus-1')}
            >
             ZX Plus-1
            </button>
            <button
              className={`nav-link ${activeComponent === 'ZX-Plus-2' ? 'active' : ''}`}
              onClick={() => handleComponentChange('ZX-Plus-2')}
            >
             ZX Plus-2
            </button>
            <button
              className={`nav-link ${activeComponent === 'ZX-Pro' ? 'active' : ''}`}
              onClick={() => handleComponentChange('ZX-Pro')}
            >
              ZX Pro Series
            </button>
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default TIJLayout;